/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowApiControllersPlanningTimeClockAdminControllerCorrectDayRequestDto,
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockDailyAttendanceDto,
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto,
  GetApiV1TimeclockAdminDailyStatusParams,
  GetApiV1TimeclockAdminEmployeesEmployeeIdHistoryParams,
  GetApiV1TimeclockAdminOverviewParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTimeClockAdmin = () => {
/**
 * @summary Get time clock history for a specific employee in a date range
 */
const getApiV1TimeclockAdminEmployeesEmployeeIdHistory = (
    employeeId: string,
    params?: GetApiV1TimeclockAdminEmployeesEmployeeIdHistoryParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>(
      {url: `/api/v1/timeclock/admin/employees/${employeeId}/history`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get time clock overview for all (or a specific) employee in a date range
 */
const getApiV1TimeclockAdminOverview = (
    params?: GetApiV1TimeclockAdminOverviewParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>(
      {url: `/api/v1/timeclock/admin/overview`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Correct time clock day for an employee (requires correction note)
 */
const postApiV1TimeclockAdminEmployeesEmployeeIdDaysDateCorrect = (
    employeeId: string,
    date: string,
    facilityFlowApiControllersPlanningTimeClockAdminControllerCorrectDayRequestDto: FacilityFlowApiControllersPlanningTimeClockAdminControllerCorrectDayRequestDto,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>(
      {url: `/api/v1/timeclock/admin/employees/${employeeId}/days/${date}/correct`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowApiControllersPlanningTimeClockAdminControllerCorrectDayRequestDto
    },
      options);
    }
  /**
 * @summary Get daily attendance status for all employees
 */
const getApiV1TimeclockAdminDailyStatus = (
    params?: GetApiV1TimeclockAdminDailyStatusParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockDailyAttendanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockDailyAttendanceDto>(
      {url: `/api/v1/timeclock/admin/daily-status`, method: 'GET',
        params
    },
      options);
    }
  return {getApiV1TimeclockAdminEmployeesEmployeeIdHistory,getApiV1TimeclockAdminOverview,postApiV1TimeclockAdminEmployeesEmployeeIdDaysDateCorrect,getApiV1TimeclockAdminDailyStatus}};
export type GetApiV1TimeclockAdminEmployeesEmployeeIdHistoryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockAdmin>['getApiV1TimeclockAdminEmployeesEmployeeIdHistory']>>>
export type GetApiV1TimeclockAdminOverviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockAdmin>['getApiV1TimeclockAdminOverview']>>>
export type PostApiV1TimeclockAdminEmployeesEmployeeIdDaysDateCorrectResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockAdmin>['postApiV1TimeclockAdminEmployeesEmployeeIdDaysDateCorrect']>>>
export type GetApiV1TimeclockAdminDailyStatusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockAdmin>['getApiV1TimeclockAdminDailyStatus']>>>
